import { reactive } from '../../js/reactive';
import { data } from './data';
import { a11yTextVNode } from '../../js/a11y';
const vNode = window.vNode;
let oldBlock = null;
export const renderTotalBlock = (container) => {
    reactive.watch(() => {
        const newBlock = vNode.create('div', { class: 'ss__cart_total-block', hidden: data.totalPrice < 1 }, [
            vNode.create('div', { class: 'ss__cart_total-block_subtotal' }, [
                vNode.create('span', { class: 'ss__cart_total-block_subtotal_title' }, ['SubTotal']),
                vNode.create('s', {
                    class: 'ss__cart_total-block_subtotal_old'
                }, [
                    a11yTextVNode('Price: '),
                    `$${data.totalOldPrice}`
                ]),
                vNode.create('span', {
                    class: 'ss__cart_total-block_subtotal_new'
                }, [
                    a11yTextVNode('Price after discounts: '),
                    `$${(data.totalPrice).toFixed(2)}`
                ])
            ]),
            vNode.create('div', { class: 'ss__cart_total-block_buttons' }, [
                vNode.create('a', { class: 'ss__cart_total-block_button-cart', href: '/cart' }, [
                    vNode.create('button', {}, ['VIEW CART'])
                ]),
                vNode.create('form', { class: 'ss__cart_total-block_button-checkout', action: '/cart', method: 'post' }, [
                    vNode.create('button', {
                        type: 'submit',
                        name: 'checkout',
                        class: 'btn:accent-gradient',
                        'data-dl-event': 'checkoutStart',
                        events: {
                            click: event => { event.currentTarget.innerHTML = '<i class="ss__cart_total-block_button-checkout_loader bdrs:50p d:inline-block"></i>'; }
                        }
                    }, ['CHECKOUT'])
                ])
            ])
        ]);
        vNode.patch(oldBlock, newBlock, container);
        oldBlock = newBlock;
    }, ['totalPrice']);
};
